import React, { useEffect, useState } from 'react';
import { CheckCircle2, Circle, X } from 'lucide-react';
import tokenManager from '../utils/tokenManager';
import toast from 'react-hot-toast';

const EventChecklistModal = ({ event, onClose, onEdit }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch(`/api/events/${event.id}/checklist`, {
          headers: { Authorization: `Bearer ${tokenManager.getToken()}` }
        });
        if (!response.ok) throw new Error('Checklist unavailable');
        setItems(await response.json());
      } catch (error) {
        toast.error('Failed to load event tasks');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [event.id]);

  const setStatus = async (item, status) => {
    try {
      const response = await fetch(`/api/events/${event.id}/checklist/${item.id}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${tokenManager.getToken()}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status })
      });
      if (!response.ok) throw new Error('Checklist update failed');
      const updated = await response.json();
      setItems(current => current.map(existing => existing.id === updated.id ? updated : existing));
    } catch (error) {
      toast.error('Failed to update task');
    }
  };

  const openItems = items.filter(item => item.status === 'open');
  const closedItems = items.filter(item => item.status !== 'open');
  const row = (item) => (
    <div key={item.id} style={{ display: 'flex', gap: '10px', padding: '10px 0', borderBottom: '1px solid #334155', opacity: item.status === 'open' ? 1 : 0.6 }}>
      <button type="button" onClick={() => setStatus(item, item.status === 'open' ? 'done' : 'open')} style={{ border: 0, background: 'transparent', color: item.status === 'open' ? '#f59e0b' : '#22c55e', padding: 0, cursor: 'pointer', display: 'flex' }}>
        {item.status === 'open' ? <Circle size={19} /> : <CheckCircle2 size={19} />}
      </button>
      <div>
        <div style={{ fontWeight: 600, textDecoration: item.status === 'open' ? 'none' : 'line-through' }}>{item.title}</div>
        {item.detail && <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '3px' }}>{item.detail}</div>}
      </div>
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: '560px' }}>
        <div className="modal-header"><div><h2>Event tasks</h2><p style={{ margin: '3px 0 0', color: '#94a3b8', fontSize: '13px' }}>{event.name}</p></div><button className="close-btn" onClick={onClose}><X size={20} /></button></div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}><button className="btn btn-secondary" type="button" onClick={onEdit}>Edit event details</button></div>
        {loading ? <p>Loading tasks...</p> : items.length === 0 ? <p>No open tasks for this event.</p> : <>
          {openItems.length > 0 && <div>{openItems.map(row)}</div>}
          {closedItems.length > 0 && <details style={{ marginTop: '15px' }}><summary style={{ cursor: 'pointer', color: '#94a3b8' }}>Completed / not needed ({closedItems.length})</summary>{closedItems.map(row)}</details>}
        </>}
      </div>
    </div>
  );
};

export default EventChecklistModal;
